import { getActiveViewAsBuyerUserId } from '../utils/viewAsBuyer';

export const paths = {
    public: {
        root: '/',
        login: '/login',
        register: '/register',
        forgotPassword: '/forgotpwd',
        landing: '/landing',
        freeAndEasy: '/F&E',
        termsOfService: '/terms-of-service',
        privacyPolicy: '/privacy-policy',
        buyerTermsOfService: '/buyer-terms-of-service',
        ndaSuccess: '/nda-success',
        docSuccess: '/doc-success',
        docNdaSuccess: '/doc-nda-success',
        docDeclined: '/doc-declined',
        docSignedFrame: '/doc-signed-frame',
        loiPrepComplete: '/loi-prep-complete',
        thankYou: '/thank-you',
        dataRequestDashboard: '/data-request-dashboard',
        dataRequestDashboardOthers: '/data-request-dashboard/others',
    },
    builtIn: {
        dataRequestDashboard: '/data-request-dashboard-built-in',
        projectEditor: '/project-editor-built-in',
    },
    account: {
        profile: '/profile',
        notifications: '/notifications',
        auditLogs: '/audit-logs',
        userHome: '/venue-selection',
        venueSelection: '/venue-selection',
        venuesHome: '/venues-home',
        dashboard: '/dashboard',
        announcements: '/announcements',
        subscriptions: '/subscriptions',
        associates: '/associates',
        charityApproval: '/charity-approval',
        standardizationServices: '/standardization-services',
    },
    venues: {
        byId: (venueId: string) => `/${venueId}`,
        grow: {
            root: '/grow',
            practices: '/grow/practices',
            practiceById: (id: string | number) => `/grow/practices/${id}`,
            knowledgeLibrary: '/grow/knowledge-library',
            practiceManagementGroups: '/grow/practice-management-groups',
            practiceManagementPmg: (id: string | number) => `/grow/practice-management-pmg/${id}`,
            myGroups: '/grow/my-groups',
            ipoc: '/grow/ipoc',
            cpoc: (id: string | number) => `/grow/cpoc/${id}`,
            practiceValuationReports: '/grow/practice-valuation-reports',
            dataRequestDashboard: '/grow/data-request-dashboard',
            dataRequestDashboardOthers: '/grow/data-request-dashboard/others',
        },
        ally: {
            root: '/ally',
        },
        connect: {
            root: '/connect',
            // While an admin is viewing as a buyer, every link into the buyer
            // marketplace must stay inside the view-as route: leaving it drops
            // the impersonation header and the page reloads as the admin.
            get opportunities(): string {
                const viewAsBuyerUserId = getActiveViewAsBuyerUserId();
                return viewAsBuyerUserId
                    ? `/connect/view-as/${viewAsBuyerUserId}`
                    : '/connect/opportunities';
            },
            viewAsBuyer: (buyerUserId: string | number) =>
                `/connect/view-as/${buyerUserId}`,
            engagement: (engagementId: string | number) =>
                `/connect/engagement/${engagementId}`,
            meetings: '/connect/meetings',
            practiceBrokerageServices: '/connect/practice-brokerage-services',
            practiceBrokerageServicesComingSoon: (isComingSoon: string) =>
                `/connect/practice-brokerage-services/${isComingSoon}`,
        },
        share: {
            root: '/share',
            myReferrals: '/share/my-referrals',
            withdraw: '/share/withdraw',
            charities: '/share/charities',
            charityEdit: (id: string | number) => `/share/charities/${id}/edit`,
            charityWithdraw: (id: string | number) => `/share/charities/${id}/withdraw`,
            donate: '/share/donate',
            nonprofits: '/share/nonprofits',
            practiceRequests: '/share/practice-requests',
            referralRequests: '/share/referral-requests',
        },
    },
    admin: {
        root: '/admin',
        controls: '/admin/controls',
        uploadChart: '/admin/upload-chart',
        pricing: '/admin/pricing',
        paidReportFromUpdates: '/admin/paidreport-from-updates',
        knowledgeLibrary: '/admin/knowledge-library',
        supportRequests: '/admin/support-requests',
        notifications: '/admin/notifications',
        legalDocuments: '/admin/legal-documents',
        documentExtraction: '/admin/document-extraction',
        publicFeRequests: '/admin/public-fe-requests',
        pmgAdmin: '/pmg-admin',
        cgmAdmin: '/cgm-admin',
        marketplace: '/marketplace/admin',
        marketplaceEngagement: (engagementId: string | number) =>
            `/marketplace/admin/engagement/${engagementId}`,
        marketplaceTemplate: (id: string | number) => `/marketplace/admin/templates/${id}`,
        marketplaceTemplatePreview: (id: string | number) =>
            `/marketplace/admin/templates/${id}/preview`,
        marketplaceEngagementEdit: (id: string | number) =>
            `/marketplace/admin/engagements/${id}`,
        landscapeMap: '/landscapemap/admin',
        maintenanceTool: '/maintenance-tool',
        practiceList: '/practice-list',
        dataAndDocumentTemplates: '/data-and-document-templates-dashboard',
        dataAndDocumentRequests: '/data-and-document-requests-dashboard',
        projectEditor: '/project-editor',
    },
    report: {
        root: '/report',
        free: '/report/free',
        evaluation: '/report/evaluation',
        apvarInput: '/report/apvarinput',
        viewFreemium: (id: string | number) => `/view/freemium/${id}`,
        viewPaidEvaluation: (id: string | number) => `/view/paidevaluation/${id}`,
        detailed: '/detailedreports',
    },
};
